<template>
    <div>
        <div class="x-footer">
            <div class="x-sub">
                <div class="item" :class="tabIndex == 1 ? 'tab-selected' : ''" @click="toPage(1)">
                    <img class="selected-img" :src="require('../../assets/icon/tab-selected.png')" />
                    <div class="tab-info">
                        <img class="sub-img" v-if="tabIndex == 1" :src="require('../../assets/icon/home-selected.png')" />
                        <img class="sub-img" v-else :src="require('../../assets/icon/home.png')" />
                        <div class="sub-txt">{{ GLOBAL.lanLocal['home'] }}</div>
                    </div>
                </div>
            </div>
            <div class="x-sub x-main" v-if="accountid == 0">
                <div class="item" :class="tabIndex == 5 ? 'tab-selected' : ''" @click="toPage(5)">
                    <img class="selected-img" :src="require('../../assets/icon/tab-selected.png')" />
                    <div class="tab-info">
                        <img class="main-img" :src="require('../../assets/icon/tab-icon.png')" />
                    </div>
                </div>
            </div>
            <div class="x-sub">
                <div class="item" :class="tabIndex == 2 ? 'tab-selected' : ''" @click="toPage(2)">
                    <img class="selected-img" :src="require('../../assets/icon/tab-selected.png')" />
                    <div class="tab-info">
                        <img class="sub-img" v-if="tabIndex == 2"
                            :src="require('../../assets/icon/activity-selected.png')" />
                        <img class="sub-img" v-else :src="require('../../assets/icon/activity.png')" />
                        <div class="sub-txt">{{ GLOBAL.lanLocal['activity'] }}</div>
                    </div>
                </div>
            </div>
            <div class="x-sub" v-if="accountid">
                <div class="item" :class="tabIndex == 3 ? 'tab-selected' : ''" @click="toPage(3)">
                    <img class="selected-img" :src="require('../../assets/icon/tab-selected.png')" />
                    <div class="tab-info">
                        <img class="sub-img" v-if="tabIndex == 3" :src="require('../../assets/icon/email.png')" />
                        <img class="sub-img" v-else :src="require('../../assets/icon/email.png')" />
                        <div class="sub-txt">{{ GLOBAL.lanLocal['email'] }}</div>
                    </div>
                    <img v-if="emailCount" class="red-dot" :src="require('../../assets/icon/red-dot.png')" />
                </div>
            </div>
            <div class="x-sub" v-if="accountid">
                <div class="item" :class="tabIndex == 4 ? 'tab-selected' : ''" @click="toPage(4)">
                    <img class="selected-img" :src="require('../../assets/icon/tab-selected.png')" />
                    <div class="tab-info">
                        <img class="sub-img" v-if="tabIndex == 4" :src="require('../../assets/icon/me.png')" />
                        <img class="sub-img" v-else :src="require('../../assets/icon/me.png')" />
                        <div class="sub-txt">{{ GLOBAL.lanLocal['me'] }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'tabbar',
    data() {
        return {
            tabIndex: 1
        }
    },
    created() {

    },
    computed: {

    },
    watch: {
        accountid :{
            immediate: true,
            handler(newValue, oldValue) {
                
            }
        },
        index :{
            immediate: true,
            handler(newValue, oldValue) {
                    this.tabIndex = newValue
            }
        },
        emailCount :{
            immediate: true,
            handler(newValue, oldValue) {
            }
        }
    },
    props: {
        accountid: {
            type: Number,
            default: 0
        },
        index: {
            type: Number,
            default: 1
        },
        emailCount: {
            type: Number,
            default: 0
        }
    },
    mounted() { },
    methods: {
        toPage(type) {
            this.tabIndex = type
            this.$emit('change', type)
        }
    }
}
</script>
<style lang="less" scoped>
.x-footer {
    display: flex;
    align-items: center;
    height: 70px;
    position: fixed;
    bottom: 0;
    width: 100%;
    z-index: 5;
    background: rgb(28, 32, 37);
}

.x-sub {
    width: 35%;
    height: 100%;
    display: flex;
    justify-content: center;

    .item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        text-align: center;
        position: relative;
        height: 100%;
        width: 70px;

        .selected-img {
            display: none;
        }
        .red-dot {
            height: 12px;
            width: 12px;
            position: absolute;
            top: 8px;
            right: 10px;
            z-index: 2;
        }
        .tab-info {
            position: absolute;
            left: 0;
            z-index: 1;
            width: 70px;
            text-align: center;

            .sub-img {
                width: 32px;
                height: 32px;
                -o-object-fit: contain;
                object-fit: contain;
                margin: 0 auto;
            }

            .sub-txt {
                color: rgb(119, 119, 119);
                white-space: nowrap;
                font-size: 13px;
                line-height: 1;
            }

            .main-img {
                width: 70px;
                height: 70px;
                -o-object-fit: contain;
                object-fit: contain;
                margin: 0 auto;
            }
        }
    }

    .tab-selected {
        .selected-img {
            width: 70px;
            height: 100%;
            display: block !important;
        }

        .tab-info {
            .sub-txt {
                color: rgb(255, 182, 0);
            }
        }
    }
}

.x-main {
    width: 30% !important;

    .item {
        .tab-info {
            bottom: 0 !important;
            height: 100% !important;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/tabbar/tabbar.vue